import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { getJsmSesameBaseUrl } from '@atlassian/jira-servicedesk-incident-management-common/src/utils.tsx';
import type { ContainerProps, EmailTemplate, State } from '../../types.tsx';

export type Response = {
	templates: EmailTemplate[];
	paginationKey: string | null;
	count: number;
};

export const fetchEmailTemplates =
	(limit: number, paginationKey?: string | null): Action<State, ContainerProps> =>
	async ({ getState, setState }, { cloudId }) => {
		const { emailTemplatesList } = getState();

		if (emailTemplatesList.isLoading) {
			return;
		}

		setState({
			emailTemplatesList: {
				...emailTemplatesList,
				isLoading: true,
				error: undefined,
			},
		});

		try {
			const queryParams = new URLSearchParams({
				limit: limit.toString(),
				...(paginationKey ? { paginationKey } : {}),
			});

			const response: Response = await fetchJson(
				`${getJsmSesameBaseUrl(cloudId)}/v1/stakeholders/template/list?${queryParams.toString()}`,
			);

			setState({
				emailTemplatesList: {
					data: paginationKey
						? [...(emailTemplatesList.data || []), ...response.templates]
						: response.templates,
					paginationKey: response.paginationKey,
					count: response.count,
					isLoading: false,
					error: undefined,
				},
			});
		} catch (e: unknown) {
			setState({
				emailTemplatesList: {
					...emailTemplatesList,
					isLoading: false,
					error: { value: e instanceof Error ? e.message : 'Unknown error' },
				},
			});
		}
	};

export const resetEmailTemplatesList =
	(): Action<State, ContainerProps> =>
	({ setState }) => {
		setState({
			emailTemplatesList: {
				data: undefined,
				paginationKey: null,
				count: 0,
				isLoading: false,
				error: undefined,
			},
		});
	};
